
import React from 'react';

const HeroSection = () => {
  return (
    <section className="relative py-20 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-brand-50 to-white"></div>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="text-center max-w-3xl mx-auto">
          <h1 className="text-3xl md:text-4xl font-bold mb-6">Kontakt</h1>
          <p className="text-lg text-gray-600 mb-8">
            Na kontaktoni për çdo pyetje, sugjerim apo bashkëpunim. Ekipi ynë është i gatshëm t'ju ndihmojë.
          </p>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
